import tool from 'common/src/modules/shared/copilot/utils/creators/tool';
import toolResult from 'common/src/modules/shared/copilot/utils/creators/toolResult';
import toolError from 'common/src/modules/shared/copilot/utils/toolError';
import {z} from 'zod';
import {ToolExecuteParams} from 'common/src/modules/shared/copilot/copilot.types';
import {V2CardAgentToolName} from '../../promptToCardAgentV2.enums';
import {NodeOutputData} from 'common/src/modules/nodes/nodes.types';
import {NodeType} from 'common/src/modules/nodes/nodes.types';
import {DistributionCardScratchpadState} from '../../scratchpad/distributionCardScratchpad.types';
import validateAgentScratchpad from '../../utils/general/validateAgentScratchpad';

const editDistributionOutputInputSchema = z.object({
  outputId: z.number().describe('The id of the output to edit'),
  name: z.string().describe('The new name for the output'),
});

export default function editDistributionOutputTool() {
  async function execute(
    params: ToolExecuteParams<
      typeof editDistributionOutputInputSchema,
      DistributionCardScratchpadState
    >,
  ) {
    const {outputId, name} = params.input;
    const validatedScratchpad = validateAgentScratchpad<DistributionCardScratchpadState>(
      params.toolUtils.agentScratchpad,
      NodeType.DISTRIBUTION,
    );
    const {card} = validatedScratchpad;

    const existingOutput = card.outputs.find((output) => output.id === outputId) as
      | NodeOutputData
      | undefined;

    if (!existingOutput) {
      return toolError(`Distribution output with id ${outputId} not found.`);
    }

    existingOutput.name = name;

    return toolResult(`Distribution output updated: name to "${name}"`);
  }

  return tool<typeof editDistributionOutputInputSchema, DistributionCardScratchpadState>({
    name: V2CardAgentToolName.EditDistributionOutput,
    displayName: 'Editing distribution output',
    description: 'Edit the name of an existing distribution output.',
    inputSchema: editDistributionOutputInputSchema,
    execute,
  });
}
